/**
 * `/session` answers 200 for an instance the caller has no access to (or one that doesn't exist),
 * but with only the public part of the payload - no `user`, `account` or `instance`. That's not a
 * crash, it's "this instance isn't available to you", so callers can tell it apart from a genuine
 * boot failure and show Page Not Found instead of the generic error screen.
 */
export class SessionInstanceUnavailableError extends Error {
  constructor() {
    super('Session is not available for the requested instance');
    this.name = 'SessionInstanceUnavailableError';
  }
}
